import * as React from "react"
import SEO from "../components/seo"
import Layout from "../components/layout"
import PrivacyPolicy from "../components/privacy-policy/privacy-policy-twf"

const IndexPage = () => {
  return (
    <Layout>
      <SEO title={'BatiGames'} />
      <PrivacyPolicy></PrivacyPolicy>
    </Layout>
  )
}

export default IndexPage